import { render, staticRenderFns } from "./CompareTableHeader.vue?vue&type=template&id=52e90d83&scoped=true&"
import script from "./CompareTableHeader.vue?vue&type=script&lang=ts&"
export * from "./CompareTableHeader.vue?vue&type=script&lang=ts&"
import style0 from "./CompareTableHeader.vue?vue&type=style&index=0&id=52e90d83&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e90d83",
  null
  
)

export default component.exports